import {
  InspectUserPayment,
  GetActivityInfoCache,
} from '@/utils/http/modules/expo/expo.request.js'
import { Toast } from 'vant'
import commonAjax from '@/utils/http/modules/common.request'
import $agent_api from '@/utils/http/modules/agent/agent.request'
import muTypes from '@/store/mutation-types.js'
import { getUserAuth } from '@/utils/http/modules/agent/auth.request'
import { getTrainContentConfig } from '@/utils/http/modules/course/course.request'
import { getParamsByKey } from '@/utils/utils'
import { $shopApi } from '@/utils/http/modules/shop/shop.request'
import { authSenceMap } from '@/pages/agent/directive/VAuth'
export default {
  // 展会/峰会 检测是否含有未付款票券
  async getExpoStatus(state, data) {
    try {
      const res = await InspectUserPayment(data)
      if (res.isok) {
        state.commit('isSignIn', res.dataObj.isSignIn)
        state.commit('isSignUp', res.dataObj.isSignUp)
        state.commit('isUserNoPayment', res.dataObj.isUserNoPayment)
        state.commit('isTicket', res.dataObj.isTicket)
        state.commit('playbackType', res.dataObj.playbackType)
      } else {
        Toast(res.msg)
      }
    } catch (err) {
      Toast(err)
    }
  },
  async getActivityInfo(state, activityId) {
    try {
      const res = await GetActivityInfoCache(activityId)
      if (res.isok) {
        state.commit('expoActivity', res.dataObj)
      } else {
        Toast(res.msg)
      }
    } catch (err) {
      Toast(err)
    }
  },
  async get_member(state) {
    try {
      const isIframe =
        window.self !== window.top &&
        window.parent.location.href.indexOf('/live/page') > -1
      let canRequest = true
      if (isIframe && window.parent.zbvd) {
        const _zbvd = window.parent.zbvd
        if (_zbvd.liveInfoVo && !_zbvd.liveInfoVo.isOpenMemberLevel) {
          canRequest = false
        }
      }
      console.log('vzanlivemobile.window.parent.zbvd: ', window.parent.zbvd)
      console.log(
        'vzanlivemobile.state.getters.isAllowMember: ',
        state.getters.isAllowMember
      )
      if (state.getters.isAllowMember && canRequest) {
        const member_res = await commonAjax.CheckMemberInfoByIds({
          zbid: window.zbvd.zbid,
          userIds: [window.userInfo.id],
        })
        if (member_res.dataObj && member_res.dataObj[0]) {
          state.commit(
            'USER_INFO',
            JSON.parse(
              JSON.stringify(
                Object.assign(window.userInfo, {
                  member: member_res.dataObj[0],
                })
              )
            )
          )
        }
      }
    } catch (err) {
      console.log('function [CheckMemberInfoByIds] error', err)
    }
  },
  async updateAgentTeamConfig(store, zbId) {
    try {
      const res = await $agent_api.getTeamLeaderInfo({ zbId })
      const data = res.dataObj
      store.commit(muTypes.setAgentTeamConfig, {
        isLeader: data.isLeader,
        roleType: data.roleType,
        ...data,
      })
      return data
    } catch (error) {
      console.error('国科直播间 获取身份失败', error)
      return {}
    }
  },
  async updateTrainConfig({ state, commit }, params) {
    getTrainContentConfig(params, false).then(res => {
      if (res.code == 0) {
        commit('USER_INFO', {
          ...state.userInfo,
          ...res.data,
          comment: res.data?.comment || { allowComment: true },
        })
      }
    })
  },

  /**
   * H5端获取用户自主核销配置
   * @param state
   * @param commit
   * @param option = {
   *       firstStore: false, 优先门店判断，如果没有门店id，会自动传入0
   *       invoke: false,  放行调用
   *     }
   * @returns {Promise<null|*>}
   */
  async getSelfVerifyConfigAction(
    { state, commit },
    option = {
      firstStore: false,
      invoke: false,
    }
  ) {
    try {
      if (
        JSON.stringify(option) ===
        JSON.stringify(state.getSelfVerifyConfigActionPrevParams)
      ) {
        return
      }
      let verificationType = '' // type=1订单列表，=2优惠券列表
      const goodsOrderPaths = [
        '/live/m/order/myorder',
        '/live/m/order/checkorder',
      ]
      const couponOrderPaths = [
        '/live/m/myCouponList',
        '/live/m/verificationCoupon',
      ]
      const pathList = [
        '/live/m/order/checkorder',
        '/live/m/verificationCoupon',
      ] // 只要这两个路径是全局请求

      if (goodsOrderPaths.includes(window.location.pathname)) {
        verificationType = 1
      } else if (couponOrderPaths.includes(window.location.pathname)) {
        verificationType = 2
      }
      const whitePath = pathList.find(item => {
        return window.location.pathname.indexOf(item) > -1
      })
      if (!whitePath && !option.invoke) return
      let paramsByKey = getParamsByKey('verificationType') || verificationType // type=1订单列表，=2优惠券列表
      let storeId = option.firstStore ? getParamsByKey('storeId') || 0 : 0
      const params = {
        zbId: window.zbvd.zbid,
        storeId: storeId || 0,
        type: paramsByKey ? Number(paramsByKey) : paramsByKey,
      }
      let res = await $shopApi.getSelfVerifyConfig(params)
      console.log('H5端获取用户自主核销配置', res)
      if (res.code === 0) {
        state.getSelfVerifyConfigActionPrevParams = option
        commit(muTypes.setSelfVerifyConfig, res.dataObj)
        return res.dataObj
      }
    } catch (e) {
      console.log(e)
    }
  },
  async upDateGlobalTime({ commit, state }) {
    try {
      const res = await commonAjax.getCurrentServiceTime()
      if (res.data && res.data.code === 0 && typeof res.data.data == 'number') {
        commit('UPDATE_TIME', res.data.data)
        return Promise.resolve(res.data.data)
      } else {
        return Promise.resolve()
      }
    } catch (e) {
      commit('UPDATE_TIME', Date.now())
      return Promise.resolve()
    } finally {
      commit('START_CLOCK')
    }
  },
  async checkAndGetAgentAuthList({ commit, state, getters }, authKey) {
    console.log('@@@@@@@', getters.getAuthDataAndAgentSetting)
    if (!state.isFetchAgentAuthList) {
      try {
        const result = await getUserAuth({})
        console.log('result =>', result)
        if (result.code === 0) {
          if (result.data.length) {
            const businessModel =
              getters.getAuthDataAndAgentSetting?.agentSetting?.businessModel ||
              0
            let list = authSenceMap(result.data, businessModel)
            commit('setAgentAuthList', list || [])
          } else {
            console.log(res)
            return false
          }
        }
      } catch (err) {
        console.log(err)
        return false
      }
    }
    return getters.getAgentAuthList.some(item => {
      if (Array.isArray(authKey)) {
        return authKey.includes(item.permCode)
      } else {
        item.permCode === authKey
      }
    })
  },
}
